import { map } from 'rxjs/operators';
import { MenuHasAccessResponse } from './responses/menu-has-access.response';
import { Observable, of } from 'rxjs';
import { environment } from './../../../../../../environments/environment';
import { LocalStorageService } from 'angular-2-local-storage';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  Module,
  Menu,
  Submenu,
  ModuleMenuResponse,
} from './responses/menu.response';
import { Accion } from 'src/app/shared/constants/accionesSeguridad';
import { Privilegio } from 'src/app/shared/constants/privilegiosSeguridad';

@Injectable({
  providedIn: 'root',
})
export class MenuService {
  data:ModuleMenuResponse = {
    "status":200,
    "error":false,
    "data":[{
    "id": "cms",
    "servicio": "CMS",
    "url": "/admin/cms",
    "icon": "fas fa-file-alt",
    "color": "#4680ff",
    "menu": [
        {
            "id": "ecommerce",
            "nombre": "Ecommerce",
            "url": "/admin/cms/ecommerce",
            "icon": "fas fa-shopping-cart",
            "color": "#9ccc65",
            "descripcion": "CMS de ecommerce",
            "sub_menu": [
                {
                    "title": "BannerHome",
                    "url": "/admin/cms/ecommerce/bannerHome",
                    "parent_id": "ecommerce"
                },
                {
                    "title": "Caja Valor Home",
                    "url": "/admin/cms/ecommerce/caja-valor",
                    "parent_id": "ecommerce"
                },
                {
                    "title": "Cápsula Home",
                    "url": "/admin/cms/ecommerce/mundoHome",
                    "parent_id": "ecommerce"
                },
                {
                    "title": "Page Home",
                    "url": "/admin/cms/ecommerce/pageHome",
                    "parent_id": "ecommerce"
                },
                {
                    "title": "Blog",
                    "url": "/admin/cms/ecommerce/blog",
                    "parent_id": "ecommerce"
                },
                {
                    "title": "Imagenes Blog",
                    "url": "/admin/cms/ecommerce/imagenes-blog",
                    "parent_id": "ecommerce"
                },
                {
                    "title": "Email Template",
                    "url": "/admin/cms/ecommerce/email-template",
                    "parent_id": "ecommerce"
                },
                {
                    "title": "Especiales",
                    "url": "/admin/cms/ecommerce/especiales",
                    "parent_id": "ecommerce"
                },
                {
                    "title": "Banners Especiales",
                    "url": "/admin/cms/ecommerce/banners-especiales",
                    "parent_id": "ecommerce"
                },
                {
                    "title": "SEO",
                    "url": "/admin/cms/ecommerce/seo",
                    "parent_id": "ecommerce"
                },
                {
                    "title": "Tiendas",
                    "url": "/admin/cms/ecommerce/tiendas",
                    "parent_id": "ecommerce"
                },
                {
                    "title": "Iconos Cyber",
                    "url": "/admin/cms/ecommerce/iconos-cyber",
                    "parent_id": "ecommerce"
                },
                {
                    "title": "Banner Tienda Oficial",
                    "url": "/admin/cms/ecommerce/tienda-oficial",
                    "parent_id": "ecommerce"
                },
                {
                    "title": "World box",
                    "url": "/admin/cms/ecommerce/world-box-cms",
                    "parent_id": "ecommerce"
                },
                {
                    "title": "Descripción Productos",
                    "url": "/admin/cms/ecommerce/descripcion-productos",
                    "parent_id": "ecommerce"
                },
                {
                    "title": "Product Home Omni",
                    "url": "/admin/cms/ecommerce/productHome",
                    "parent_id": "ecommerce"
                }
            ]
        }
    ]
  }] }
  authBasic = 'Basic c2VydmljZXM6MC49ajNEMnNzMS53Mjkt';
  pais = environment.PAIS;
  getheaders() {
    return environment.urlCampania.startsWith('http://192')
      ? {}
      :new HttpHeaders().append('Authorization', this.authBasic);
  }
  constructor(private http: HttpClient, private localS: LocalStorageService) {
  }

  menu(): Observable<ModuleMenuResponse> {
    const codUsuario: any = this.localS.get('codUsuario');
    const codPerfil: any = this.localS.get('codPerfil');
    if(this.pais == 'ES') {
      // let headers = this.getheaders();
      // const url = `${environment.urlCampania}/getModuleMenus?cod_usuario=${codUsuario}&cod_perfil=${codPerfil}`;
      // return this.http.get<ModuleMenuResponse>(url,{headers}).pipe(map(result => {
      //   result.data = result.data.map(menuModule => {
      //     return this.mapMenuModule(menuModule);
      //   });
      //   return result;
      // }));
      return of(this.data).pipe(map((result: any) => {
        result.data = result.data.map((menuModule) => {
          return this.mapMenuModule(menuModule);
        });
        return result;
      }));

    }else{
      const url = `${environment.urlSeguridad}/getModuleMenus?cod_usuario=${codUsuario}&cod_perfil=${codPerfil}`;
      return this.http.get<ModuleMenuResponse>(url).pipe(
        map((result) => {
          result.data = result.data.map((menuModule) => {
            return this.mapMenuModule(menuModule);
          });
          return result;
        })
      );
    }
  }

  private mapMenuModule(menuModule: Module): Module {
    menuModule.menu = menuModule.menu.map((menu) => {
      return this.mapMenu(menu);
    });
    return menuModule;
  }

  private mapMenu(menu: Menu): Menu {
    menu.sub_menu = menu.sub_menu.map((submenu) => {
      return this.mapSubmenu(submenu);
    });
    return menu;
  }

  private mapSubmenu(submenu: Submenu): Submenu {
    if (submenu.url.includes('?')) {
      const tokens = submenu.url.split('?');
      submenu.url = tokens[0];
      submenu.queryParams = {};
      const searchParams = new URLSearchParams(tokens[1]);
      searchParams.forEach((val, key) => (submenu.queryParams[key] = val));
    } else {
      submenu.queryParams = {};
    }
    return submenu;
  }

  hasAccess(url: string): Observable<MenuHasAccessResponse> {
    const codUsuario: any = this.localS.get('codUsuario');

    const urlRequest = `${environment.urlSeguridad}/hasAccess?cod_usuario=${codUsuario}`;
    return this.http.post<MenuHasAccessResponse>(urlRequest, {
      url,
      cod_usuario: codUsuario,
    });
  }

  hasUpdateAccess(
    accion: Accion,
    codUsuarioOmni: number = null
  ): Observable<MenuHasAccessResponse> {
    const codUsuario: number =
      codUsuarioOmni == null ? this.localS.get('codUsuario') : codUsuarioOmni;

    const urlRequest = `${environment.urlSeguridad}/hasUpdateAccess`;
    return this.http.post<MenuHasAccessResponse>(urlRequest, {
      url: accion.url,
      accionId: accion.id,
      cod_usuario: codUsuario,
    });
  }

  hasPrivileges(
    privilegio: Privilegio,
    codUsuarioOmni: number = null
  ): Observable<MenuHasAccessResponse> {
    const codUsuario: number =
      codUsuarioOmni == null ? this.localS.get('codUsuario') : codUsuarioOmni;
    const urlRequest = `${environment.urlSeguridad}/hasPrivileges`;
    return this.http.post<MenuHasAccessResponse>(urlRequest, {
      url: privilegio.url,
      privilegioId: privilegio.id,
      cod_usuario: codUsuario,
    });
  }
}
